import { selectKrcCurriculumSubDomainNode } from '@newStore/documentUI/transformContent/krcContentNodeSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const KRC_CURRICULUM_SUBDOMAIN: BuildingBlockNodeConfig = {
  nodeSelector: selectKrcCurriculumSubDomainNode,
  information: {
    single: 'Subdomein',
    plural: 'Subdomeinen',
  },
  buildingBlocks: [{ type: NodeType.KRC_CURRICULUM_CLUSTER }, { type: NodeType.KRC_GOAL_SET_ITEM }],
  edit: [
    {
      ...titleComponent,
      width: 10,
    },
  ],
  documentViewIdentifier: 'i',
  isCollapsible: true,
  isCollapsedByDefault: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default KRC_CURRICULUM_SUBDOMAIN;
